import React from "react";
import { cn } from "@/lib/utils";
import { Textarea } from "@/components/ui/textarea";
import { StickyNote } from "lucide-react";

interface NotesFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  maxLength?: number;
  rows?: number;
  className?: string;
}

export function NotesField({
  value,
  onChange,
  placeholder = "Notizen hier eingeben...",
  maxLength = 1000,
  rows = 4,
  className,
}: NotesFieldProps) {
  const charCount = value?.length || 0;

  return (
    <div className={cn("space-y-2", className)}>
      <div className="relative">
        <Textarea
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          maxLength={maxLength}
          rows={rows}
          className="resize-none pr-10"
        />
        <StickyNote className="absolute top-3 right-3 h-4 w-4 text-muted-foreground" />
      </div>
      
      <div className="flex justify-end">
        <span className={cn(
          "text-xs",
          charCount > maxLength * 0.9 ? "text-amber-500" : "text-muted-foreground"
        )}>
          {charCount} / {maxLength}
        </span>
      </div>
    </div>
  );
}
